<template>
  <div class="data-loader">
    <q-inner-loading showing>
      <q-spinner size="50px" color="secondary" />
      <span class="message"> {{ label }} </span></q-inner-loading
    >
  </div>
</template>

<script>
export default {
  props: {
    label: String,
  },
};
</script>

<style lang="scss">
.data-loader {
  .q-inner-loading {
    background: rgba(255, 255, 255, 1);
    .message {
      margin-top: 1em;
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
    }
  }
}

// Dark Mode
.body {
  &--dark {
    .data-loader {
      .q-inner-loading {
        background: var(--q-color-dark);
      }
    }
  }
}
</style>
